module.exports = __webpack_public_path__ + "static/img/type2-en.236185d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/n-prenata-test/type2-en.png
// module id = CDme
// module chunks = 1